import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MediaInstance, Upload } from '../../../model/datatypes';
import { ImporttodraftService } from '../../../provider/importtodraft.service';
import { MediaService } from '../../../provider/media.service';
import { UploadService } from '../../../provider/upload.service';

@Component({
  selector: 'upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatFormField, MatInput, MatProgressBar, MatButton]
})
export class UploadFormComponent implements OnInit {
  public upSvc = inject(UploadService);
  private httpClient = inject(HttpClient);
  private mediaSvc = inject(MediaService);
  private importtodraftSvc = inject(ImporttodraftService);

  @Input() type!: string; //'single_image', 'ada', or 'bitmap_collection'
  @Input() multiple!: boolean;
  @Input() accepts!: string;
  @Input() source!: string; //'mixer', 'share'


  progress: number = 0;
  selectedFiles!: FileList | undefined;
  uploading: boolean = false;
  imageToShow: any;
  downloadid!: string;

  @ViewChild('uploadImage') canvas!: ElementRef;

  @Output() onData: any = new EventEmitter();
  @Output() onError: any = new EventEmitter();



  detectFiles(event: any) {
    this.selectedFiles = event.target.files;
  }

  async uploadAda(upload: Upload, file: File) {
    await this.upSvc.pushUpload(upload).then(snapshot => {
      return this.upSvc.getDownloadData(upload.name)
    }).then(url => {
      this.httpClient.get(url).toPromise()
        .then(data => {
          var obj = {
            name: file.name.split(".")[0],
            data: data,
            type: 'ada',
          }
          this.onData.emit(obj);
          this.uploading = false;
          this.selectedFiles = undefined;
          this.upSvc.deleteUpload(upload.name);

        })





    });

  }




  uploadImage(upload: Upload, file: File, type: 'image' | 'indexed_color_image'): Promise<any> {


    return this.upSvc.pushUpload(upload).then(snapshot => {

      const media_instance: MediaInstance = {
        id: -1,
        ref: upload.name,
        type: type,
        img: null
      }

      return this.mediaSvc.loadMediaFromUpload([media_instance]);
    }).then(uploaded => {


      this.onData.emit(uploaded);
      this.uploading = false;
      this.selectedFiles = undefined;

    }).catch(e => {
      console.error("error uploading image", e);
      this.onError.emit(e);
      this.uploading = false;
      this.selectedFiles = undefined;
    });
  }





  upload() {

    this.uploading = true;
    if (this.selectedFiles == undefined) return;

    console.log("uploading", this.selectedFiles, this.type);

    let uploadList = [];
    if (this.multiple) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        let file: File | null = this.selectedFiles.item(i);
        if (file) {
          let fileType = file.name.split(".").pop();
          let fileName = file.name.split(".")[0];
          uploadList.push({ file: file, fileName: fileName, fileType: fileType });
        }
      }
    } else {
      const first_file = this.selectedFiles?.item(0);
      uploadList.push({ file: first_file as File, fileName: first_file?.name.split(".")[0] ?? '', fileType: first_file?.name.split(".").pop() ?? '' });
    }


    for (let uploadObj of uploadList) {
      const upload: Upload = {
        $key: '',
        file: uploadObj.file,
        name: uploadObj.fileName,
        fileType: uploadObj.fileType as string,
        url: '',
        progress: 0,
        createdAt: new Date()
      };





      switch (this.type) {
        case 'ada':
          this.uploadAda(upload, uploadObj.file);
          break;

        case 'indexed_color_image':
          this.uploadImage(upload, uploadObj.file, 'indexed_color_image')

          break;

        case 'single_image':
          this.uploadImage(upload, uploadObj.file, 'image')
          break;

        case 'wif':
          this.importtodraftSvc.uploadWif(upload, uploadObj.file as File).then(
            res => {
              this.onData.emit();
              this.uploading = false;
              this.selectedFiles = undefined;
            }).catch(e => {
              this.onError.emit(e);
              this.uploading = false;
              this.selectedFiles = undefined;
            });
          break;

        case 'bitmap':
          this.importtodraftSvc.uploadBitmap(upload, uploadObj.file as File, uploadObj.fileType as string).then(
            res => {
              this.onData.emit(res);
              this.uploading = false;
              this.selectedFiles = undefined;
            }).catch(e => {
              this.onError.emit(e);
              this.uploading = false;
              this.selectedFiles = undefined;
            });
          break;


        default:
          break;
      }
    }




  }


  ngOnInit() {
  }

}
